/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useContext, useEffect, useState } from "react";
import cn from "classnames";
import { CsCheckBoxItem } from "./CsCheckBoxItem";
import { LayoutContext } from "../../components/layout";

export const CsCheckbox = ({ data, interrogationStats, globalShow, setInterrogationStats }) => {
  const { headerDetails: userInfo } = useContext(LayoutContext);
  const [show, setShow] = useState(false);
  const [initShow, setInitShow] = useState(false);
  const showHideIcon = require("./../../assets/esign-ui-icons/ico-showhide.svg");

  useEffect(() => {
    setShow(globalShow);
  }, [globalShow]);

  const init = () => {
    let show = false;
    if (data.esignStatements.some((item) => item.interrogationStatements[0].isused)) {
      show = true;
    }
    setInitShow(show);
  };

  useEffect(() => {
    init();
  }, [userInfo, interrogationStats]);

  if (initShow || globalShow)
    return (
      <>
        <div
          className="grp-hdr"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {globalShow || initShow ? <h3>{data.name}:</h3> : null}
          <button
            className="btn btn-sm btn-hide-section btn-hide-show"
            onClick={(e) => {
              e.preventDefault();
              setShow(!show);
            }}
          >
            <span style={{ color: "#555" }}>{show ? "Hide" : "Show"}</span>
            <img id="loading-spinner" src={showHideIcon} className={cn("showhide-ico", { show: !show })} />
          </button>
        </div>
        {data.esignStatements.map((item, ii) => {
          if (show || item.interrogationStatements[0].isused)
            return (
              <CsCheckBoxItem
                key={`checkboxitem-${ii}`}
                item={item}
                interrogationStats={interrogationStats}
                setInterrogationStats={setInterrogationStats}
              />
            );
        })}
      </>
    );
  else return null;
};
